import { render } from "./SalaryDetail.vue?vue&type=template&id=045c6536"
import script from "./SalaryDetail.vue?vue&type=script&lang=js"
export * from "./SalaryDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__